import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketUsers = ({ dispatch }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  ****************
  //  ** Use Effect **
  //  ****************
  useEffect(() => {  
    const socket = getSocket();

    if (socket) {
      const handleUsers = (data) => {
        if ((data.action === "update" || data.action === "create") && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: "UPDATE_USERS", payload: data.user });
        }
  
        if ((data.action === "delete") && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: "DELETE_USER", payload: +data.userId });
        }
      };
  
      socket.on("user", handleUsers);
  
      return () => {
        socket.off("user", handleUsers);
      };
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  
  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketUsers;